import { Component } from '@angular/core';
import { FileService } from './../../shared/services/file.service';
import { StorageService } from '../../shared/services/storage.service';
import { EncryptionService } from '../../shared/services/encryption.service';

@Component({
    selector: 'home',
    templateUrl: 'home.component.html'
})
export class HomeComponent{

    vUserType: string = '';

    constructor(
        private _encryptionService: EncryptionService,
        private _storageService: StorageService,
        private _fileService : FileService,
    ){}

    ngOnInit(){
        //console.log(this._storageService.getLocalItem('email'));
        //this._encryptionService.decodeToken(localStorage.getToken('idToken'));
        this.vShow = {
            customer: false,
            admin: false,
            plantmap_ops: false,
            nce_ops: false
        };
        this.getRole();
    }

    vShow : {
        customer: boolean,
        admin: boolean,
        plantmap_ops: boolean,
        nce_ops: boolean
    }

    downloadEarthworksRequirements() {        
        this._fileService.getMiscSignedDownloadRequest('annex.pdf');
    }

    getRole(){
        var accesses;
        
        try{
            accesses = JSON.parse(this._storageService.getLocalItem('access'));
        }catch(e){
            accesses = null;
        }
        if(this.actionChecking('PURPL', accesses) && this.actionChecking('PURNCE', accesses)){ //CUST
            this.vShow.customer = true;
        }
        if(this.actionChecking('MANINU', accesses)){ // ADMN
            this.vShow.admin = true;
        }
        if(this.actionChecking('MANPL', accesses)){ // PLOP
            this.vShow.plantmap_ops = true;
        }
        if(this.actionChecking('MANNCE', accesses)){ // NCEO
            this.vShow.nce_ops = true;
        }
    }

    actionChecking(type, accesses) {
        for(var access of accesses){
            if(access == type){
                return true;
            }
        }
        return false;
    }
    
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/home/components/home.component.ts